var map = {
	"./alert.svg": "bfa8",
	"./basket.svg": "1c23",
	"./bookings.svg": "f5dc",
	"./contacts.svg": "28d7",
	"./courses.svg": "ba4c",
	"./dashboard.svg": "e950",
	"./delete.svg": "4edd",
	"./donations.svg": "d857",
	"./download.svg": "22b4",
	"./edit.svg": "582c",
	"./email.svg": "b267",
	"./eye-slash.svg": "28ed",
	"./eye.svg": "4111",
	"./file-pdf.svg": "7945",
	"./house.svg": "68ee",
	"./id-card-alt.svg": "cfab",
	"./link-symbol.svg": "50b3",
	"./lock.svg": "d0fc",
	"./logo-dark.svg": "7113",
	"./logo.svg": "1ea0",
	"./mailchimp.svg": "29a8",
	"./meal.svg": "f8b9",
	"./my-account.svg": "d8a1",
	"./notes.svg": "68c8",
	"./paperclip.svg": "0d20",
	"./purchase.svg": "e671",
	"./restore.svg": "2dae",
	"./search.svg": "c6a2",
	"./send.svg": "5977",
	"./settings.svg": "53df",
	"./user-management.svg": "8d52",
	"./wordpress.svg": "3ed6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57ae";